<div class="content">
	<div class="grid grid-auto-1 grid-full-height">
		<div class="width-400 content">
			<div class="layout-auto-1-auto">
				<exg-search-bar (Search)="config.table.search($event)" [placeholder]="getRessource('SearchHolder')">
<!-- 					<ng-template #rightTemplate> -->
<!-- 						<i class="search-action far fa-sync"></i> -->
<!-- 					</ng-template> -->
				</exg-search-bar>
				<div class="content">
					<exg-data-list #VCmainTable [rowSource]="viewTable.data"
					               [selectKey]="viewTable.selectKey"
					               [allowSingleSelection]="true"
					               (RowChange)="viewTable.selectionChanged($event)">
						<ng-template #rowTemplate let-field>
							<div class="list-row-auto-1">
								<div></div>
								<div class="list-primary-text typo-small">
									{{enumSvc.getFieldCaption('Receipt', field)}}
								</div>
							</div>
						</ng-template>
					</exg-data-list>
				</div>
				<exg-pager class="span-layout" *ngIf="viewTable.state === 0"
				           (PageChange)="viewTable.pageChanged($event)"
				           [pagingSource]="viewTable.paging">
					<ng-template #leftTemplate>
					</ng-template>
					<ng-template #rightTemplate>
						<span *ngIf="viewTable.isFiltered()">(gefiltert)</span>
					</ng-template>
				</exg-pager>
			</div>
		</div>
		<div class="content">

		</div>
	</div>
</div>
